const numerals = {
  western: '0123456789',
  persian: '۰۱۲۳۴۵۶۷۸۹',
  eastern: '٠١٢٣٤٥٦٧٨٩',
};
export type NumeralSystem = keyof typeof numerals;

// converts numerals to some variant of the Hindu-Arabic numeral system
export const convertNumerals = (number: string, to: NumeralSystem = 'western') =>
  number.replace(
    /[0-9۰-۹٠-٩]/g,
    (d) =>
      numerals[to][numerals.western.indexOf(d)] ??
      numerals[to][numerals.eastern.indexOf(d)] ??
      numerals[to][numerals.persian.indexOf(d)] ??
      '',
  );
